import {inlineError} from '@s-ui/decorators'
import {Repository} from '@s-ui/domain'

/**
 * @interface
 * */
export class PageRepository extends Repository {
  /**
   * @method
   * @return {Error}
   */
  @inlineError
  getCurrentUrl() {
    throw new Error('[PageRepository#getCurrentUrl] must be implemented')
  }

  /**
   * @method
   * @return {Error}
   */
  @inlineError
  getRemoteUrl() {
    throw new Error('[PageRepository#getRemoteUrl] must be implemented')
  }
}
